// extracted by mini-css-extract-plugin
export default {"editYearButton":"edit-calendar-button_editYearButton__Rd1wr","icon":"edit-calendar-button_icon__y5RiY"};